import React from 'react';
import Typography from '@mui/material/Typography';
import Disclaimer from '@components/Disclaimer';

const Instructions = ({ showMain }: { showMain: boolean }) => {
  return (
    <>
      <Disclaimer />
      {showMain ? (
        <Typography
          variant="body1"
          sx={{ fontStyle: 'italic', textAlign: 'left' }}
          gutterBottom
        >
          Enter the Amazon URL to any product to get an organized list of an
          item’s sizes, prices and colors!{' '}
          <strong>
            Example: If a screwdriver comes in 30 colors, but you just want to
            know which is cheapest!
          </strong>{' '}
        </Typography>
      ) : null}
    </>
  );
};

export default Instructions;
